import { useId, type ReactNode } from 'react';
import { cn } from '../../lib/cn';

/** A titled part of a detail panel. */
export function PanelSection({
  title,
  description,
  action,
  children,
  tone = 'default',
  className,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  tone?: 'default' | 'danger';
  className?: string;
}) {
  const id = useId();
  return (
    <section aria-labelledby={id} className={cn('space-y-3 px-4 py-4 sm:px-5', className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3
            id={id}
            className={cn('text-body font-semibold', tone === 'danger' ? 'text-critical-ink' : 'text-ink')}
          >
            {title}
          </h3>
          {description && <p className="mt-0.5 text-mini text-ink-muted">{description}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {children}
    </section>
  );
}
